<template>
  <div class="container">
    <div class="nav">
      <Btnav></Btnav>
    </div>

    <div
      class="banner"
      :style=" 'background-image: url(' + this.banner + ');background-size: cover;'"
    >
      <div class="banner-text">
        <div>{{bannertext1}}</div>
        <div>{{bannertext2}}</div>
      </div>
    </div>
    <div class="service">
      <div class="service1">
        <div class="service1l">
          <p class="servicep">{{servicep}}</p>
          <div class="servicesp1" style="width: 100%;">{{this.strs[0]}}</div>
          <div class="servicesp2" style="width: 100%;">{{this.strs[1]}}</div>
        </div>
        <div class="service1r">
          <img style="margin-bottom:30px" :src="this.image_one" alt />
          <img :src="this.image_two" alt />
        </div>
      </div>
    </div>

    <div class="inn2">
      <p class="inn1-2p">{{inn12p}}</p>
      <div class="inn2-2-1">
        <div
          class="inn2-2-1-1"
          :style="'width: ' + joincenter + '0%;'"
          v-for="(item,index) in this.joinarray"
          :key="index"
        >
          <p>
            <img class="inn2-img" :src="item.image" alt />
          </p>
          <p class="innp1">{{ischinese == "cn" ?item.title:item.title_en}}</p>
          <p class="innp2">{{ischinese == "cn" ?item.menu:item.menu_en}}</p>
        </div>
      </div>
    </div>

    <Btfooter></Btfooter>
  </div>
</template>
<script>
import Btnav from "../../components/dashu/nav";
import Btfooter from "../../components/dashu/footer";
export default {
  components: { Btnav, Btfooter },
  data() {
    return {
      banner: "",
      currentPage4: 1,
      joinarray: [],
      joincenter: 5,
      strs: [],
      image_one: "",
      image_two: "",
      ischinese: "cn",
      servicep: "为什么加入我们",
      inn12p: "招聘内容",
      bannertext1: "加入我们",
      bannertext2: "许给未来一个可能",
    };
  },
  created() {
    this.ischinese = window.localStorage.getItem("ischinese") || "cn";
    if (this.ischinese == "en") {
      this.servicep = "Why to Join Us";
      this.inn12p = "Recruitment Content";
      this.bannertext1 = "Join Us";
      this.bannertext2 = "Promise a Possibility to the Future";
    }

    this.$http
      .post("/api/dashu/recruit/recruitList", {})
      .then(res => {
        // console.log(res.data.data)
        var code = res.data.code;
        if (code === 0) {
          if (this.ischinese == "cn") {
            this.banner = res.data.data.banner.image;
            this.joinarray = res.data.data.recruit;
            this.image_one = res.data.data.joins.image_one;
            this.image_two = res.data.data.joins.image_two;
            var str4 = res.data.data.joins.content;
            var strs4 = str4.split("\n");
            this.strs = strs4;
            //  console.log(this.joinarray.length)
            if (this.joinarray.length >= 3) {
              //  console.log("1")
              this.joincenter = 3;
            }
          } else if (this.ischinese == "en") {
            this.banner = res.data.data.banner.image;
            this.joinarray = res.data.data.recruit;
            this.image_one = res.data.data.joins.image_one;
            this.image_two = res.data.data.joins.image_two;
            var str4 = res.data.data.joins.content_en;
            var strs4 = str4.split("\n");
            this.strs = strs4;
            //  console.log(this.joinarray.length)
            if (this.joinarray.length >= 3) {
              //  console.log("1")
              this.joincenter = 3;
            }
          }
        }
      })
      .catch(function(error) {
        //  console.log(error);
      });
  },
  methods: {}
};
</script>
<style scoped>
body {
  position: relative;
}
.container {
  background-color: white;
  min-width: max-content;
  min-width: -moz-max-content;
}
.nav {
  overflow: hidden !important;
}
.nav {
  position: absolute;
  top: 0;
  z-index: 10;
  width: 100%;
  min-width: 1200px;
  /* background-size: 100% 100%; */
  background-position: center center;
  background-repeat: no-repeat;
}
.banner {
  overflow: hidden !important;
  position: relative;
  /* background-size: 100% 100%; */
  background-position: center center;
  background-repeat: no-repeat;
  width: 100%;
  min-width: 1200px;
  height: 606px;
  /* margin-top: 57px; */
}

.service {
  height: 867px;
  /* width:1900px; */
  background: white;
}
.service1,
.service2 {
  width: 1200px;
  height: 400px;
  margin: 0 auto 30px;
  display: flex;
}
.service1l {
  height: 370px;
  width: 685px;
  padding-top: 200px;
}
.service1r {
  height: 360px;
  width: 480px;
  padding: 140px 40px 0;
}
.servicep {
  font-size: 30px;
  line-height: 30px;
  /* padding-left:10px; */
  font-weight: bold;
}
.servicesp1,
.servicesp2 {
  color: grey;
  font-size: 16px;
  line-height: 30px;
  width: 590px;
}
.servicesp1 {
  margin: 50px 0 30px 0;
}

.inn2 {
  /* padding:20px auto 50px; */
  width: 100%;
  background: #f3f3f3;
  padding-bottom: 110px;
}
.inn1-2p {
  font-size: 30px;
  font-weight: bold;
  width: 1180px;
  margin: 40px auto 65px;
  padding-top: 69px;
}
.inn2-2-1 {
  display: flex;
  width: 1180px;
  flex-wrap: wrap;
  margin: 0 auto;
}
.inn2-2-1-1 {
  width: 30%;
}
.inn2-img {
  width: 241px;
  height: 201px;
}
.innp1 {
  color: black;
  font-size: 22px;
  text-align: center;
}
.innp2 {
  color: #888888;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
  padding: 0 20%;
}
.inn2-2-1-1 {
  text-align: center;
}

.banner-text {
  width: 100%;
  text-align: center;
  font-size: 70.34px;
  color: #ffffff;
  padding-top: 125px;
}
.banner-text div {
  width: 700px;
  margin: 0 auto;
  text-align: left;
}
</style>




// WEBPACK FOOTER //
// src/pages/pcPages/Ajoin.vue